module.exports = __webpack_public_path__ + "static/media/background_img1.d50d35dc.png";